import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Technology Analyst at <span className="purple">Accenture</span>. CS Alumni from UNT, foused on Cloud Engineering. Based in <span className="purple"> Dallas, TX</span>.
            <br />
            <br />
             When I'm not building on AWS, I'm:
            <ul>
              <li className="about-activity">
                <ImPointRight /> Playing Games
              </li>
              <li className="about-activity">
                <ImPointRight /> Rock Climbing
              </li>
              <li className="about-activity">
                <ImPointRight /> Playing my Guitar
              </li>
            </ul>
            <br />
             I'm drawn to hard problems — the kind that take a few tries to get right.
            <br />
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
